import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "form-group col-md-5" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-group col-md-7" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "form-group col-md-6" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "form-group col-md-6" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "trigger", { click: _ctx.open }),
    _createVNode(_component_modal, {
      modelValue: _ctx.modal,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modal) = $event)),
      "allow-close": ""
    }, {
      header: _withCtx(() => _cache[11] || (_cache[11] = [
        _createTextVNode("Edit Article")
      ])),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.modal = !_ctx.modal)),
            class: "btn btn-default mx-2"
          }, "Cancel"),
          _createElementVNode("button", {
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.update && _ctx.update(...args))),
            class: "btn btn-primary"
          }, "Save")
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[12] || (_cache[12] = _createElementVNode("label", null, "Title", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            name: "social-title",
            class: _normalizeClass([{'is-invalid':!_ctx.validation.title}, "form-control"]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
            required: "",
            maxlength: "250"
          }, null, 2), [
            [_vModelText, _ctx.title]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "hidden",
            name: "article_id",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.id) = $event))
          }, null, 512), [
            [_vModelText, _ctx.id]
          ]),
          (!_ctx.validation.title)
            ? (_openBlock(), _createElementBlock("small", _hoisted_2, "A title is required"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[13] || (_cache[13] = _createElementVNode("label", null, "Description", -1)),
          _withDirectives(_createElementVNode("textarea", {
            class: _normalizeClass([{'is-invalid':!_ctx.validation.description}, "form-control"]),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.description) = $event)),
            maxlength: "400",
            required: "",
            rows: "3"
          }, null, 2), [
            [_vModelText, _ctx.description]
          ]),
          (!_ctx.validation.description)
            ? (_openBlock(), _createElementBlock("small", _hoisted_4, "A description is required"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[14] || (_cache[14] = _createElementVNode("label", null, "Article Text", -1)),
          _withDirectives(_createElementVNode("textarea", {
            class: _normalizeClass([{'is-invalid':!_ctx.validation.article_text}, "form-control"]),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.article_text) = $event)),
            required: "",
            rows: "8"
          }, null, 2), [
            [_vModelText, _ctx.article_text]
          ]),
          (!_ctx.validation.article_text)
            ? (_openBlock(), _createElementBlock("small", _hoisted_6, "The main body of the article is required"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[16] || (_cache[16] = _createElementVNode("label", null, "Author", -1)),
            _cache[17] || (_cache[17] = _createTextVNode("   ")),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selected_author) = $event))
            }, [
              _cache[15] || (_cache[15] = _createElementVNode("option", { value: null }, " -- Select An Author --", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authorsObj, (author) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: author.author_id,
                  value: author.author_id
                }, _toDisplayString(author.full_name), 9, _hoisted_9))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.selected_author]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _cache[18] || (_cache[18] = _createElementVNode("label", null, "Publish On", -1)),
            _cache[19] || (_cache[19] = _createTextVNode("   ")),
            _createVNode(_component_datepicker, {
              class: _normalizeClass([{'is-invalid':!_ctx.validation.published_on}, "form-control"]),
              "lower-limit": _ctx.dateRange,
              modelValue: _ctx.published_on,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.published_on) = $event))
            }, null, 8, ["class", "lower-limit", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[20] || (_cache[20] = _createElementVNode("label", null, "Current Web Image (Small)", -1)),
            _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("img", {
              src: _ctx.image_path,
              width: "150",
              alt: "Current Image",
              title: "Currnet Social Media Image"
            }, null, 8, _hoisted_13),
            _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1)),
            _cache[23] || (_cache[23] = _createElementVNode("label", null, "Upload a New Image", -1)),
            _cache[24] || (_cache[24] = _createTextVNode()),
            _cache[25] || (_cache[25] = _createElementVNode("small", null, [
              _createElementVNode("i", null, "Max Size 5MB")
            ], -1)),
            _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("input", {
              type: "file",
              ref: "imageFile",
              class: "form-control",
              onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onAttachment && _ctx.onAttachment(...args))),
              accept: "image/jpeg, image/png"
            }, null, 544)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[27] || (_cache[27] = _createElementVNode("label", null, "Current Socail OG Image (Large)", -1)),
            _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("img", {
              src: _ctx.image_path_large,
              width: "200",
              alt: "Current OG Image",
              title: "Currnet OG Tag Image"
            }, null, 8, _hoisted_15),
            _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
            _cache[30] || (_cache[30] = _createElementVNode("label", null, "Upload a New Image", -1)),
            _cache[31] || (_cache[31] = _createTextVNode()),
            _cache[32] || (_cache[32] = _createElementVNode("small", null, [
              _createElementVNode("i", null, "Max Size 5MB")
            ], -1)),
            _cache[33] || (_cache[33] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("input", {
              type: "file",
              ref: "imageFileLarge",
              class: "form-control",
              onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onAttachmentSocial && _ctx.onAttachmentSocial(...args))),
              accept: "image/jpeg, image/png"
            }, null, 544)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}